module.exports = __webpack_public_path__ + "img/s4.4c2dec7f.jpg";